export const getGeoInfo = (options) => ({
    geo: options.geo,
    region: options.region,
});
